const testimonials = [
  {
    name: 'Marcus Chen',
    handle: '@marcusfinds',
    text: 'The kakobuy spreadsheet saved me hours of scrolling through random seller pages. Found a pair of Jordans at nearly half the price I was seeing elsewhere. Totally worth bookmarking.',
    color: 'bg-accent-100',
  },
  {
    name: 'Sarah Mitchell',
    handle: '@sarahmstyle',
    text: 'I was skeptical about spreadsheet shopping, but the kakobuyspreadsheet guides made it feel like having a personal shopper. The seller comparison feature is genuinely useful.',
    color: 'bg-secondary-100',
  },
  {
    name: 'David Okafor',
    handle: '@davidkicks',
    text: 'Best kakobuy spreadsheet resource hands down. I check it every morning before making any purchase. The daily updates make a real difference in catching deals early.',
    color: 'bg-primary-100',
  },
  {
    name: 'Emily Rojas',
    handle: '@emilybags',
    text: 'As someone new to spreadsheet buying, the safety tips alone were worth the visit. KakobuySpreadsheet helped me avoid two sketchy sellers I would have otherwise bought from.',
    color: 'bg-foreground-100',
  },
  {
    name: 'James Wu',
    handle: '@jamesreps',
    text: 'Used the kakobuy spreadsheet to source inventory for my small reselling business. The category filters are clean, and the links actually work — which is more than I can say for most aggregators.',
    color: 'bg-accent-100',
  },
  {
    name: 'Priya Nair',
    handle: '@priyashops',
    text: 'Finally a kakobuy spreadsheet that is actually maintained. The buying guides taught me things about sizing and seller negotiation I never would have figured out on my own.',
    color: 'bg-secondary-100',
  },
];

export default function TestimonialSection() {
  return (
    <section id="testimonials" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-6">
        <div className="mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-3">
            Buyer Reviews
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Trusted by Thousands
          </h2>
          <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            of Global Buyers
          </p>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 space-y-5">
          {testimonials.map((t) => (
            <div
              key={t.handle}
              className="break-inside-avoid p-5 rounded-2xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <span className={`w-10 h-10 flex items-center justify-center rounded-full ${t.color} text-foreground-700 font-semibold text-sm`}>
                  {t.name.charAt(0)}
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.handle}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                &ldquo;{t.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}